<template>
    <!--活动介绍-->
    <view class="p30">
        <view class="title p30 bg-white f30 lh200 radius8">
			  <view>活动主题：{{ activity.activity_title }}</view>
              <view>报名时间：{{ activity.register_time_text }}</view>
			  <view v-if="activity.activity_fee > 0">报名费用：<text class="red">￥{{ activity.activity_fee }}</text>元</view>
			  <view>活动时间：{{ activity.activity_time_text }}</view>
			  <view>联系电话：{{ activity.phone }}</view>
			  <view>活动地址：{{ activity.address }}</view>
        </view>
        <view class="content p30 bg-white f30 lh200 radius8"  v-html="detail">

        </view>
    </view>
</template>

<script>
	import utils from '@/common/utils.js';
    export default {
        data() {
            return {
                detail: '',
				activity:{}
            }
        },
		onLoad(e) {
			/*活动id*/
			this.activity_id = e.activity_id;
		},
        mounted(){
            uni.showLoading({
                title: '加载中'
            });
            this.getData();
        },
        methods: {
            getData(){
                let self = this;
				let activity_id = self.activity_id;
                self._get('plus.regactivity.index/detail', {activity_id: activity_id}, function (res)
                {
					/*详情内容格式化*/
					self.detail =utils.format_content(res.data.detail.activity_content);
					self.activity = res.data.detail;
                    uni.hideLoading();
                });
            }
        }
    }
</script>

<style>

</style>
